import { GET_BUSINESS_PROFILE } from '../Actions/actionTypes';
export default (state={},action)=>{
  switch(action.type){
    case GET_BUSINESS_PROFILE:

      return action.payload;
    default:
      return state;
  }
}